var parseuri = require('../../../node_modules/parseurl/index');
var queryParser = require('./queryParser').init(window);

function Calculator(allowedDomain, webUrl) {

    function endsWith(str, suffix) {
        return str.indexOf(suffix, str.length - suffix.length) !== -1;
    }

    function isAllowedRedirectUri(redirectUri) {
        var allowedRedirectDomain = allowedDomain || "";
        if (allowedRedirectDomain === "") {
            return false;
        }

        var parsedUri = parseuri(redirectUri);
        return parsedUri.host === "" || endsWith(parsedUri.host, allowedRedirectDomain);
    }

    function calculate() {
        var queryParams = queryParser.parseFromCurrentUrl();
        if (queryParams.redirect && isAllowedRedirectUri(queryParams.redirect)) {
            return queryParams.redirect;
        }
        else {
            return webUrl + ("/dashboard");
        }
    }

    return {
        calculate: calculate
    };
}

module.exports = {
    init: function (allowedDomain, webUrl) {
        return Calculator(allowedDomain, webUrl);
    }
};
